/**
 * Enum for Application Environments.
 * @readonly
 * @enum {String} EnvEnum
 */

const EnvEnum = {
  DEV  : 'DEV',
  TRIAL: 'TRIAL',
  LIVE : 'LIVE'
}

export default EnvEnum
